import "./NoEvent.css";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import InfoOutline from "~/content/icons/info-outline.svg?react";

export function NoEvent({ testId, studyLocked }) {
  const { t } = useTranslation();

  const message = studyLocked
    ? t("home.no_scheduled_events")
    : t("home.no_scheduled_events_for_now");

  return (
    <section className="no-event" data-testid={testId}>
      <InfoOutline aria-hidden="true" className="no-event__icon" />
      <p className="no-event__message">{message}</p>
    </section>
  );
}

NoEvent.propTypes = {
  testId: PropTypes.string,
  studyLocked: PropTypes.bool.isRequired,
};
